<ion-header>
  <ion-toolbar>
    <ion-icon name="dp-cross" (click)="dismiss()"></ion-icon>
    <ion-title>Configuración de pendientes</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="title-container">
    <div class="title" [class.openned]="types.normal" (click)="toggleType('normal')">Servicios normales</div>
    <div class="action-buttons">
      <ion-button fill="clear" size="small" class="secondary" (click)="copyPendings('normal', $event)" title="Copiar">
        <ion-icon name="copy-outline"></ion-icon>
        Copiar
      </ion-button>
      <ion-button fill="clear" size="small" class="secondary" (click)="pastePendings('normal', $event)" title="Pegar">
        <ion-icon name="clipboard-outline"></ion-icon>
        Pegar
      </ion-button>
      <ion-button fill="clear" size="small" class="cancel secondary" (click)="clearPendings('normal', $event)"
        title="Limpiar">
        <ion-icon name="dp-trash"></ion-icon>
        Limpiar
      </ion-button>
    </div>
    <ion-searchbar [(ngModel)]="searchFilters.normal" placeholder="Buscar zona..." (click)="$event.stopPropagation()"
      class="searchbar"></ion-searchbar>
  </div>
  <div class="services" [class.openned]="types.normal">
    <div class="service" *ngFor="let zone of getFilteredZones('normal')" (click)="togglePending(zone._id, 'normal')">
      <div class="service-name">{{zone.name}}</div>
      <ion-checkbox [checked]="pendings.normal.includes(zone._id)"></ion-checkbox>
    </div>
  </div>

  <div class="title-container">
    <div class="title" [class.openned]="types.reserve" (click)="toggleType('reserve')">Servicios reservas</div>
    <div class="action-buttons">
      <ion-button fill="clear" size="small" class="secondary" (click)="copyPendings('reserve', $event)" title="Copiar">
        <ion-icon name="copy-outline"></ion-icon>
        Copiar
      </ion-button>
      <ion-button fill="clear" size="small" class="secondary" (click)="pastePendings('reserve', $event)" title="Pegar">
        <ion-icon name="clipboard-outline"></ion-icon>
        Pegar
      </ion-button>
      <ion-button fill="clear" size="small" class="cancel secondary" (click)="clearPendings('reserve', $event)"
        title="Limpiar">
        <ion-icon name="dp-trash"></ion-icon>
        Limpiar
      </ion-button>
    </div>
    <ion-searchbar [(ngModel)]="searchFilters.reserve" placeholder="Buscar zona..." (click)="$event.stopPropagation()"
      class="searchbar"></ion-searchbar>
  </div>
  <div class="services" [class.openned]="types.reserve">
    <div class="service" *ngFor="let zone of getFilteredZones('reserve')" (click)="togglePending(zone._id, 'reserve')">
      <div class="service-name">{{zone.name}}</div>
      <ion-checkbox [checked]="pendings.reserve.includes(zone._id)"></ion-checkbox>
    </div>
  </div>

  <div class="title-container">
    <div class="title" [class.openned]="types.priority" (click)="toggleType('priority')">Servicios prioritarios</div>
    <div class="action-buttons">
      <ion-button fill="clear" size="small" class="secondary" (click)="copyPendings('priority', $event)" title="Copiar">
        <ion-icon name="copy-outline"></ion-icon>
        Copiar
      </ion-button>
      <ion-button fill="clear" size="small" class="secondary" (click)="pastePendings('priority', $event)" title="Pegar">
        <ion-icon name="clipboard-outline"></ion-icon>
        Pegar
      </ion-button>
      <ion-button fill="clear" size="small" class="cancel secondary" (click)="clearPendings('priority', $event)"
        title="Limpiar">
        <ion-icon name="dp-trash"></ion-icon>
        Limpiar
      </ion-button>
    </div>
    <ion-searchbar [(ngModel)]="searchFilters.priority" placeholder="Buscar zona..." (click)="$event.stopPropagation()"
      class="searchbar"></ion-searchbar>
  </div>
  <div class="services" [class.openned]="types.priority">
    <div class="service" *ngFor="let zone of getFilteredZones('priority')"
      (click)="togglePending(zone._id, 'priority')">
      <div class="service-name">{{zone.name}}</div>
      <ion-checkbox [checked]="pendings.priority.includes(zone._id)"></ion-checkbox>
    </div>
  </div>

  <div class="title-container">
    <div class="title" [class.openned]="types.special" (click)="toggleType('special')">Servicios largos</div>
    <div class="action-buttons">
      <ion-button fill="clear" size="small" class="secondary" (click)="copyPendings('special', $event)" title="Copiar">
        <ion-icon name="copy-outline"></ion-icon>
        Copiar
      </ion-button>
      <ion-button fill="clear" size="small" class="secondary" (click)="pastePendings('special', $event)" title="Pegar">
        <ion-icon name="clipboard-outline"></ion-icon>
        Pegar
      </ion-button>
      <ion-button fill="clear" size="small" class="cancel secondary" (click)="clearPendings('special', $event)"
        title="Limpiar">
        <ion-icon name="dp-trash"></ion-icon>
        Limpiar
      </ion-button>
    </div>
    <ion-searchbar [(ngModel)]="searchFilters.special" placeholder="Buscar zona..." (click)="$event.stopPropagation()"
      class="searchbar"></ion-searchbar>
  </div>
  <div class="services" [class.openned]="types.special">
    <div class="service" *ngFor="let zone of getFilteredZones('special')" (click)="togglePending(zone._id, 'special')">
      <div class="service-name">{{zone.name}}</div>
      <ion-checkbox [checked]="pendings.special.includes(zone._id)"></ion-checkbox>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button (click)="savePendings()" fill="clear" class="general">
      Guardar
    </ion-button>
  </ion-toolbar>
</ion-footer>